import { path } from 'ramda';
import { delay } from 'redux-saga';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import contactService from 'services/contactService';

import history from 'utils/browserHistory';

import { entitiesStore } from '../entities/actions';
import {
  contactDetails,
  deleteContact,
  fetchContact,
  types,
  updateContactsAccount,
} from './actions';
import { updateMetadata } from './actions';
import { getContactId } from './reducer';

export default function* root() {
  yield takeLatest(types.CONTACT_DETAILS_INIT, watchFetchContact);
  yield takeLatest(types.DELETE_CONTACT_REQUEST, watchDeleteContact);
  yield takeLatest(types.FETCH_CONTACT_REQUEST, watchFetchContact);
  yield takeLatest(
    types.UPDATE_CONTACTS_ACCOUNT_REQUEST,
    watchUpdateContactsAccount,
  );
  yield takeLatest(types.UPDATE_METADATA_REQUEST, watchUpdateMetadata);
}

function* watchDeleteContact() {
  try {
    const contactId = yield select(getContactId);
    yield call(contactService.contacts.delete, contactId);
    // hack to let us re-index es
    yield delay(1750);
    yield put(deleteContact.success());
    history.goBack();
  } catch (error) {
    yield put(deleteContact.error(error));
  }
}

function* watchFetchContact() {
  try {
    const contactId = yield select(getContactId);
    const response = yield call(contactService.contacts.get, contactId);
    yield put(entitiesStore.receiveContact(response));
    yield put(fetchContact.success());
  } catch (error) {
    yield put(fetchContact.error(error));
  }
}

function* watchUpdateContactsAccount(action) {
  try {
    const contactId = yield select(getContactId);
    const requestData = {
      accountId: action.payload.accountId,
    };
    const response = yield call(
      contactService.contacts.update,
      contactId,
      requestData,
    );
    yield put(entitiesStore.receiveContact(response));
    yield put(updateContactsAccount.success());
  } catch (error) {
    yield put(updateContactsAccount.error(error));
  }
}

function* watchUpdateMetadata(action) {
  try {
    const contactId = yield select(getContactId);
    const { metadata } = action.payload;
    const response = yield call(contactService.contacts.update, contactId, {
      metadata,
    });
    yield put(entitiesStore.receiveContact(response));
    yield put(updateMetadata.success());
  } catch (error) {
    yield put(updateMetadata.error(error));
  }
}

export function* initContactDetailsPage({ match }) {
  const contactId = path(['params', 'contactId'], match);
  yield put(contactDetails.init({ contactId }));
}
